import {generateReport, resetSummaryCard, createRedline, updateRedline, deleteRedline} from './CostEstimationFunctions';

// Sketch Create
export function handleSketchCreate(sketch) {
    sketch.on("create", async function (event) {
        if (event.state === "complete") {
            const geometry = event.graphic.geometry;

            if (geometry.type === "polyline") {
                createRedline(geometry).then(id => {
                    if (id) {
                        event.graphic.attributes.id = id;
                        console.log("Redline ID:", id);
                        generateReport(id);
                    } else {
                        console.warn("Redline creation failed or returned no ID.");
                    }
                });
            }
        }
    });
}

// Sketch Update includes on selection
export function handleSketchUpdate(sketch, graphicsLayer) {
    sketch.on("update", async function (event) {
        if (event.state == "active" && !event.aborted) {
            // if (!isPointerDown) 
            {
                event.graphics.forEach((graphic, index) => {
                    if (graphic.geometry.type == "polyline") {
                        // Call  API
                        updateRedline(graphic.attributes.id, graphic.geometry).then(id => {
                            // Only support a single line selection
                            if (event.graphics.length == 1) {
                                generateReport(graphic.attributes.id);
                            }
                        });
                    }
                });
            }
        }
        if (event.state === "complete" && !event.aborted) {
            event.graphics.forEach((graphic, index) => {
                if (graphic.geometry.type == "polyline") {
                    // Call  API
                    updateRedline(graphic.attributes.id, graphic.geometry).then(id => {
                        // Only support a single line selection
                        if (event.graphics.length == 1) {
                            const selectedGraphics = graphicsLayer.graphics.items.filter(graphic => graphic.attributes?.selected);
                            if (selectedGraphics.length > 0)
                            {
                                generateReport(graphic.attributes.id);
                            }
                        }
                    });
                }
            });
        }

        if (event.state === "start") {
            // Only support a single line selection
            if (event.graphics.length == 1) {
                event.graphics.forEach((graphic, index) => {
                    // console.log(`Feature ${index + 1} attributes:`, graphic.attributes);
                    console.log("UPDATE ID: " + graphic.attributes.id)
                    if (graphic.attributes.id != null) {
                        generateReport(graphic.attributes.id);
                    }
                });
            }
        }
    });
}


// Sketch Delete
export function handleSketchDelete(sketch) {
    sketch.on("delete", function (event) {
        console.log("Graphic deleted:", event.graphics);
        event.graphics.forEach((graphic, index) => {
            console.log(graphic.attributes.id);
            deleteRedline(graphic.attributes.id);
        });
        // Handle deletion logic here
        resetSummaryCard();
    });
}

// Sketch Redo
export function handleSketchRedo(sketch) {
    sketch.on("redo", async function (event) {
        event.graphics.forEach((graphic, index) => {
            if (graphic.geometry.type == "polyline") {
                // Call  API
                updateRedline(graphic.attributes.id, graphic.geometry).then(id => {
                    // Only support a single line selection
                    if (event.graphics.length == 1) {
                        generateReport(graphic.attributes.id);
                    }
                });
            }
        });
    });
}

// Sketch Undo
export function handleSketchUndo(sketch) {
    sketch.on("undo", async function (event) {
        event.graphics.forEach((graphic, index) => {
            if (graphic.geometry.type == "polyline") {
                // Call  API
                updateRedline(graphic.attributes.id, graphic.geometry).then(id => {
                    // Only support a single line selection
                    if (event.graphics.length == 1) {
                        generateReport(graphic.attributes.id);
                    }
                });
            }
        });
    });
}